import { Button } from "antd";
import { FileAddOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { hasNodes } from "../../utils/hasNodes";
import SidebarActionButton from "./SidebarActionButton";
import { addVariable } from "../../utils/addVariables";



export const renderEntradasOptions = (handleAdd, t, nodes) => (
  <div className="sidebar-buttons padding-button">
    <Button
      type="default"
      icon={<CheckCircleOutlined />}
      onClick={() => handleAdd("contextInputIntentNode")}
      disabled={hasNodes({ type: "contextInputIntentNode", nodes })}
    >
      {t("common:intents.flow_chat.context.input")}
    </Button>
    <Button
      type="default"
      icon={<CheckCircleOutlined />}
      onClick={() => handleAdd("phrasesInput")}
      disabled={hasNodes({ type: "phrasesInput", nodes })}
    >
      {t("common:intents.flow_chat.entry.add")}
    </Button>
    <Button
      type="default"
      icon={<CheckCircleOutlined />}
      onClick={() => handleAdd("eventIntentNode")}
      disabled={hasNodes({ type: "eventIntentNode", nodes })}
    >
      {t("common:intents.flow_chat.event.event_add")}
    </Button>
  </div>
);

export const renderRespuestasOptions = (handleAdd, t, nodes) => (
  <div className="sidebar-buttons  padding-button">
    <Button
      type="default"
      icon={<CheckCircleOutlined />}
      onClick={() => handleAdd("contextOutputIntentNode")}
      disabled={hasNodes({ type: "contextOutputIntentNode", nodes })}
    >
      {t("common:intents.flow_chat.context.output")}
    </Button>
    <Button
      type="default"
      icon={<CheckCircleOutlined />}
      onClick={() => handleAdd("responsePhrasesIntentNode")}
      disabled={hasNodes({ type: "responsePhrasesIntentNode", nodes })}
    >
      {t("common:intents.flow_chat.response.response_select")}
    </Button>
    <Button
      type="default"
      icon={<CheckCircleOutlined />}
      onClick={() => handleAdd("conditionalResponsesIntentNode")}
      disabled={hasNodes({ type: "conditionalResponsesIntentNode", nodes })}
    >
      {t("common:intents.flow_chat.conditional_responses.add")}
    </Button>
  </div>
);

export const renderDefaultOptions = (handleAdd, actionButtons) => (
  <div className="sidebar-buttons  padding-button">
    {actionButtons.map(({ type, icon, label, disabled }) => (
      <SidebarActionButton
        key={type}
        icon={icon}
        label={label}
        onClick={() => handleAdd(type, true)}
        disabled={disabled}
      />
    ))}
  </div>
);
export const renderExtensionsOptions = (
  handleAdd,
  t,
  nodes,
  propsVariables
) => (
  <div className="sidebar-group  padding-button">
    <span className="sidebar-group-title">
      {t("common:intents.flow_chat.extension")}
    </span>
    <Button
      icon={<CheckCircleOutlined />}
      block
      onClick={() => handleAdd("extensionConfigIntentNode")}
      disabled={hasNodes({ type: "extensionConfigIntentNode", nodes })}
    >
      {t("common:intents.flow_chat.extension")}
    </Button>
    <Button
      icon={<CheckCircleOutlined />}
      block
      onClick={() => {
        addVariable({
          variables: propsVariables.variables,
          intent: propsVariables.intent,
          updateVariables: propsVariables.updateVariables,
          updateIntent: propsVariables.updateIntent,
        });
        handleAdd("extensionsVariablesFlow", false, {
          indexParam: propsVariables.variables.length - 1,
          addButton: "ButtonAddExtension",
        });
      }}
    >
      {t("common:intents.flow_chat.add_variable")}
    </Button>
  </div>
);

export const renderParameterOptions = (handleAdd, t) => (
  <div className="sidebar-group">
    <span className="sidebar-group-title">
      {t("common:intents.flow_chat.parameter")}
    </span>
    <Button
      icon={<CheckCircleOutlined />}
      block
      onClick={() => handleAdd("ParameterConfigIntentNode")}
    >
      {t("common:intents.flow_chat.parameter")}
    </Button>
  </div>
);

export const renderIntegrationsOptions = (handleAdd, t, nodes) => (
  <div className="sidebar-group">
    <Button
     disabled={hasNodes({ type: "integrationConfigIntentNode", nodes })}
      icon={<CheckCircleOutlined />}
      block
      onClick={() => handleAdd("integrationConfigIntentNode")}
    >
      {t("common:intents.flow_chat.integration")}
    </Button>
  </div>
);